import { Typography, IconButton, makeStyles, Button } from '@material-ui/core';
import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from 'react-redux';
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
	missingIVMBtn: {
		color: 'red',
	},
}));

// adding close button for dialog.
const DialogTitle = (props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
};
// Component to just view source file in a dialog.
const MissingProductsDialog = () => {
	const missingProducts = useSelector((state) => state.missingProducts);
	const [open, setOpen] = useState(false);
	const classes = useStyles();
	useEffect(() => {
		// display a dialog with all missing IVM's from Bulk search.
		if (missingProducts.length > 0) {
			setOpen(true);
		} else {
			setOpen(false);
		}
	}, [missingProducts]);
	const handleClose = () => {
		setOpen(false);
	};
	const handleClickOpen = () => {
		setOpen(true);
	};
	const titleProps = {
		classes,
		onClose: handleClose,
	};
	if (missingProducts.length > 0) {
		return (
			<>
				<Button onClick={handleClickOpen} variant="text" className={classes.missingIVMBtn}>
					Missing Product IVM's
				</Button>
				<Dialog
					open={open}
					className={classes.dialog}
					fullWidth={true}
					onClose={handleClose}
					aria-labelledby="missing-products-dialog"
					data-cy="missing-products-dialog"
					maxWidth="lg"
				>
					<DialogTitle id="missing-products-dialog" {...titleProps}>
						Missing product IVM's
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="missing-products-dialog"></DialogContentText>
						{missingProducts.map((p, index) => {
							return (
								<Typography variant="body1">{`${index + 1}. ${p.item}-${p.vendor}-${
									p.model
								}`}</Typography>
							);
						})}
					</DialogContent>
				</Dialog>
			</>
		);
	}
	return null;
};

export default MissingProductsDialog;
